var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-loading',{attrs:{"active":_vm.active,"is-full-page":_vm.isFullPage}},[_c('figure',{staticClass:"image is-48x48"},[_c('img',{attrs:{"src":"/img/loading.gif"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }